import React from 'react';
import { MapPin, Users, Image as ImageIcon } from 'lucide-react';

const RealizationCard = ({ item, onClick }) => {
  const isPlaceholder = item.placeholder;
  const hasImages = item.images && item.images.length > 0;
  const imageCount = hasImages ? item.images.length : 0;

  return (
    <div
      onClick={() => !isPlaceholder && hasImages && onClick(item)}
      className={`group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all ${isPlaceholder ? 'opacity-60' : 'cursor-pointer'}`}
      data-testid={`realization-card-${item.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
        {isPlaceholder || !hasImages ? (
          <div className="w-full h-full flex flex-col items-center justify-center text-gray-400">
            <ImageIcon className="w-16 h-16 mb-2" />
            <span className="text-sm">Photos à venir</span>
          </div>
        ) : (
          <>
            <img src={item.images[0]} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            {imageCount > 1 && (
              <div className="absolute top-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1">
                <ImageIcon className="w-3 h-3" />
                {imageCount} photos
              </div>
            )}
            <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform">
              <span className="inline-block px-3 py-1 bg-orange-500 text-white text-xs font-medium rounded-full">{item.category}</span>
            </div>
          </>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-semibold text-gray-900 mb-2">{item.title}</h3>
        {item.description && <p className="text-sm text-gray-600 mb-3">{item.description}</p>}
        <div className="flex items-center gap-4 text-sm text-gray-500">
          <span className="flex items-center gap-1"><MapPin className="w-4 h-4" />{item.location}</span>
          {!isPlaceholder && item.guests > 0 && (
            <span className="flex items-center gap-1"><Users className="w-4 h-4" />{item.guests} personnes</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default RealizationCard;
